import { useNavigate, useLocation } from "react-router-dom";
import { useCallback, useState } from "react";

export function useOfferNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const offer = location.state;

  const goBack = () => navigate(-1);

  return { offer, goBack };
}

export function useProfileNavigation() {
  const navigate = useNavigate();
  // const location = useLocation();
  // const offer = location.state;

  const goBack = () => navigate(-1);

  return { goBack };
}

function oldSchoolCopy(text: string) {
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand("copy");
  document.body.removeChild(tempTextArea);
}


export function useCopyToClipboard() {
  const [state, setState] = useState<string | null>(null);

  const copyToClipboard = useCallback((value: string) => {
    const handleCopy = async () => {
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
          setState(value);
        } else {
          throw new Error("writeText not supported");
        }
      } catch (e) {
        oldSchoolCopy(value);
        setState(value);
      }
    };

    handleCopy();
  }, []);

  return {
    copiedText: state,
    copyToClipboard,
  };
}